
import React, { createContext, useContext, useMemo } from "react";
import { useSessionManager } from "./useSessionManager";
import SessionWarningModal from "./SessionWarningModel";
// import SessionWarningModal from "./SessionWarningModal";

// ============================================
// CONTEXT
// ============================================
const SessionContext = createContext(null);

export const useSession = () => {
  const context = useContext(SessionContext);
  if (!context) {
    throw new Error("useSession must be used within SessionProvider");
  }
  return context;
};

// ============================================
// PROVIDER
// ============================================
export const SessionProvider = ({ children, options = {} }) => {
  const {
    showWarning,
    timeLeft,
    isActive,
    formatTimeLeft,
    extendSession,
    logout,
    updateActivity,
  } = useSessionManager(options);

  const contextValue = useMemo(
    () => ({
      showWarning,
      timeLeft,
      isActive,
      formatTimeLeft,
      extendSession,
      logout,
      updateActivity,
    }),
    [showWarning, timeLeft, isActive, formatTimeLeft, extendSession, logout, updateActivity]
  );

  return (
    <SessionContext.Provider value={contextValue}>
      {children}
      
      {/* Warning Modal */}
      <SessionWarningModal
        isOpen={showWarning}
        timeLeft={formatTimeLeft()}
        onExtend={extendSession}
        onLogout={logout}
      />
    </SessionContext.Provider>
  );
};

export default SessionProvider;
